import React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { parseQueryString, toNumber } from "../../utils/formatters";
import { fetchLoanApplicationPrePopData, markStepAsInterstitial } from "../../actions/loanApplicationActions";
import { marketCodeChanged } from "../../actions";
import Banner from "../ComboAppPage/Banner/banner";
import { BannerDetails } from "../../bannerDetails";
import Input from "../Forms/Input/input";
import InterstitialErrorPage from "./interstitialErrorPage";
import InterstitialNotification from "./interstitialNotification";
import { minLength, notEmpty, required } from "../../utils/validate";
import "./interstitialPage.scss";

const objectIsNotEmpty = (obj) => Object.keys(obj).length > 0 && obj.constructor === Object;


const shouldButtonBeDisabled = (text) => {
  return text === undefined || text.length !== 4;
};

const validateCode = minLength.bind(null, 4);

const InterstitialForm = reduxForm({ form: 'interstitial' })((props) => (
  <form autoComplete="off" noValidate="novalidate" className="interstitial-input" onSubmit={props.handleSubmit}>
    <span className="interstitial-text-span">
      <Field
        name="interstitial-text"
        label="Last 4 digits of Social Security"
        component={Input}
        type="text"
        normalize={toNumber}
        validate={[required, notEmpty, validateCode]}
        required={true}
        styles={{ input: ["interstitial-text"] }}
        htmlAttributes={{
          id: "interstitial-text",
          minLength: "4",
          maxLength: "4"
        }}
      />
    </span>
    <button type="submit" disabled={props.disableButton}
      className="interstitial-submit btn bcus-btn bcus-btn-secondary-dark-cyan bottom-shadow">Continue
    </button>
  </form>
));

const isUserLocked = (affiliateError) => affiliateError && affiliateError[0].code === "401";
const isSsnInValid = (affiliateError) => affiliateError && affiliateError[0].code === "400";

export class InterstitialPage extends React.Component {

  componentWillMount() {
    const queryObject = parseQueryString(this.props.location.search);
    this.props.marketCodeChanged(this.props.affiliateName);
    this.props.markStepAsInterstitial();

    this.onSubmit = (verificationCode) => {
      this.props.fetchLoanApplicationPrePopData(queryObject.token,
        queryObject.apr, queryObject.termInMonths, verificationCode);
    };
  }

  render() {
    const { affiliateError } = this.props;
    if (objectIsNotEmpty(this.props.loanApplication)) {
      return (<Redirect push to="/ck/apply"/>);
    } else if (isUserLocked(affiliateError)) {
      return ( <InterstitialErrorPage/>);
    } else {
      return (<div className="interstitial-page container-fluid">
        <Banner bannerDetails={BannerDetails.CREDIT_KARMA}/>
        <div className="interstitial-form">
          <div className="interstitial-form-header">

            <h1>Thank you, for choosing<span className="d-block strong">Barclays Personal Loan</span></h1>
            { isSsnInValid(affiliateError) ? <InterstitialNotification/> : <article/> }
            <div className="interstitial-form-paragraph">
              <span>Let's verify your identity so we can get things started.&nbsp;</span>
              <span>Please enter the last four digits of your Social Security Number.</span>
            </div>
            <InterstitialForm
              onSubmit={() => this.onSubmit(this.props.interstitialText)}
              disableButton={shouldButtonBeDisabled(this.props.interstitialText)}
            />
          </div>
          <div className="interstitial-form-footer">
            <div className="footer-text">Absolutely <span className="bold">NO Fees</span></div>
            <div className="footer-text">Receive funds <span className="bold">within a few days</span></div>
          </div>
        </div>
      </div>);
    }
  }
}

const mapStateToProps = (state) => ({
  loanApplication: state.loanApplication,
  affiliateError: state.errors,
  interstitialText: formValueSelector('interstitial')(state, 'interstitial-text')
});

const mapDispatchToProps = {
  fetchLoanApplicationPrePopData, marketCodeChanged, markStepAsInterstitial
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InterstitialPage));
